import React, { useState, useEffect, useCallback } from "react";
import {
  BiCheck,
  BiCopyright,
  BiHash,
  BiRecycle,
  BiTrashAlt,
} from "react-icons/bi";
import { BsFillBookmarksFill, BsGearFill } from "react-icons/bs";
import { BsThreeDotsVertical } from "react-icons/bs";
import { v4 as uuidv4 } from "uuid";
import { RiMessage2Fill, RiSurveyFill } from "react-icons/ri";

import { connect } from "react-redux";
import axios from "../../../axios";
import * as url from "../../../utils/url";
import * as actionCreators from "../../../modules/actions/index";
import Loading from "../../../hoc/Loading/Loading";


function TrivvySmsCounter({ user }) {
  const orgObject = user.profile.organizationId;

  return (
    <span>
      {orgObject ? (
        <div>
          <div className="remaining_text mb-3">
          <RiMessage2Fill className="mr-1" /> {orgObject.smsLimit -
              orgObject.totalSmsSent}{" "}
             remaining{" "}
          </div>
        </div>
      ) : (
        ""
      )}
    </span>
  );
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    orgChangeSuccess: (data) => dispatch(actionCreators.orgChangeSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Loading(TrivvySmsCounter, axios));
